// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PMehOutlinedSvg from "@fishx/icons-svg/es/asn/PMehOutlined";
import FishxIcon from '../components/FishxIcon';

var PMehOutlined = function PMehOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PMehOutlinedSvg
  }));
};

PMehOutlined.displayName = 'PMehOutlined';
export default React.forwardRef(PMehOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PMehOutlined.js
// module id = 3508
// module chunks = 0